import type {
  BlogIndexRoute,
  BlogPage,
} from "../blog-variant";
import "@tento-ui/brand/blog/blog-featured-grid";
import "@tento-ui/brand/blog/blog-news-table";
import "@tento-ui/brand/blog/blog-claude-pagelet";
import "@tento-ui/brand/blog/blog-hero";
import { BlogClaudePagelet } from "@tento-ui/brand/blog/blog-claude-pagelet";
import { BlogFeaturedGrid } from "@tento-ui/brand/blog/blog-featured-grid";
import { BlogHero } from "@tento-ui/brand/blog/blog-hero";
import { BlogNewsTable } from "@tento-ui/brand/blog/blog-news-table";

let $grid: Option<BlogFeaturedGrid> = null;
let $table: Option<BlogNewsTable> = null;

export const claudeRoute: BlogIndexRoute = {
  make(props: BlogPage.Props, delegate: BlogPage.Delegate): HTMLElement {
    $grid = BlogFeaturedGrid.makeWith(makeGridProps(props, delegate));
    $table = BlogNewsTable.makeWith(makeTableProps(props, delegate));
    return BlogClaudePagelet.makeWith({
      hero: makeHero(),
      featuredGrid: $grid,
      newsTable: $table,
    });
  },
  bind(pagelet: HTMLElement, props: BlogPage.Props, delegate: BlogPage.Delegate): HTMLElement {
    $grid?.bind(makeGridProps(props, delegate));
    $table?.bind(makeTableProps(props, delegate));
    return pagelet;
  },
};

function makeGridProps(props: BlogPage.Props, delegate: BlogPage.Delegate): BlogFeaturedGrid.Props {
  return {
    posts: props.featuredPosts,
    variant: "claude",
    onCardClick: delegate.onCardClick,
  };
}

function makeTableProps(props: BlogPage.Props, delegate: BlogPage.Delegate): BlogNewsTable.Props {
  return {
    posts: props.posts.filter((post) => !post.featured),
    displayCount: props.displayCount,
    searchQuery: props.searchQuery,
    onSearch: delegate.onSearch,
    onSeeMore: delegate.onSeeMore,
    onCardClick: delegate.onCardClick,
  };
}

function makeHero(): HTMLElement {
  return BlogHero.makeWith({
    title: "Newsroom",
    ctas: [
      { label: "Press inquiries", href: "mailto:press@lona.so" },
      { label: "Non-media inquiries", href: "mailto:support@lona.so" },
      { label: "Media assets", href: "/press-kit" },
    ],
  });
}
